import { cloneDeep } from '../../../../utils/lodash-min';

export interface GLFXFilterConfig {
    name: string;
    blur: number;
    brightness: number;
    contrast: number;
    tint: number;
    saturation: number;
    vignette: number;
    xpro: number;
}
export interface GLFXFilter {
    [name: string]: GLFXFilterConfig;
}

export const GLFXFilterValueMap = {
    curves: { '0': { 'red': [[0, 0], [0.3, 0.3], [0.7, 0.7], [0.95, 0.95]], 'green': [[0, 0], [0.25, 0.25], [0.6, 0.6], [1, 1]], 'blue': [[0, 0], [0.3, 0.3], [0.5, 0.5], [1, 1]] }, '27': { 'red': [[0, 0], [0.3, 0.25], [0.7, 0.73], [1, 1]], 'green': [[0, 0], [0.25, 0.22], [0.75, 0.78], [1, 1]], 'blue': [[0, 0.05], [0.3333333333333333, 0.35], [0.6666666666666667, 0.65], [1, 0.95]] }, '29': { 'red': [[0, 0], [0.3, 0.24], [0.7, 0.73], [1, 1]], 'green': [[0, 0], [0.25, 0.22], [0.75, 0.78], [1, 1]], 'blue': [[0, 0.06], [0.3333333333333333, 0.35333333333333333], [0.6666666666666667, 0.6466666666666667], [1, 0.94]] }, '30': { 'red': [[0, 0], [0.3, 0.24], [0.7, 0.73], [1, 1]], 'green': [[0, 0], [0.25, 0.22], [0.75, 0.78], [1, 1]], 'blue': [[0, 0.06], [0.3333333333333333, 0.35333333333333333], [0.6666666666666667, 0.6466666666666667], [1, 0.94]] }, '40': { 'red': [[0, 0], [0.3, 0.21999999999999997], [0.7, 0.74], [1, 1]], 'green': [[0, 0], [0.25, 0.21], [0.75, 0.79], [1, 1]], 'blue': [[0, 0.08], [0.3333333333333333, 0.36], [0.6666666666666667, 0.64], [1, 0.92]] }, '50': { 'red': [[0, 0], [0.3, 0.19999999999999998], [0.7, 0.75], [1, 1]], 'green': [[0, 0], [0.25, 0.2], [0.75, 0.8], [1, 1]], 'blue': [[0, 0.1], [0.3333333333333333, 0.3666666666666667], [0.6666666666666667, 0.6333333333333333], [1, 0.9]] }, '60': { 'red': [[0, 0], [0.3, 0.18], [0.7, 0.76], [1, 1]], 'green': [[0, 0], [0.25, 0.19], [0.75, 0.81], [1, 1]], 'blue': [[0, 0.12], [0.3333333333333333, 0.3733333333333333], [0.6666666666666667, 0.6266666666666667], [1, 0.88]] }, '69': { 'red': [[0, 0], [0.3, 0.15999999999999998], [0.7, 0.77], [1, 1]], 'green': [[0, 0], [0.25, 0.18], [0.75, 0.8200000000000001], [1, 1]], 'blue': [[0, 0.14], [0.3333333333333333, 0.38], [0.6666666666666667, 0.62], [1, 0.86]] }, '80': { 'red': [[0, 0], [0.3, 0.13999999999999999], [0.7, 0.7799999999999999], [1, 1]], 'green': [[0, 0], [0.25, 0.16999999999999998], [0.75, 0.83], [1, 1]], 'blue': [[0, 0.16], [0.3333333333333333, 0.3866666666666666], [0.6666666666666667, 0.6133333333333333], [1, 0.84]] }, '-23': { 'red': [[0, 0], [0.3, 0.25], [0.7, 0.58], [0.95, 0.96]], 'green': [[0, 0], [0.25, 0.28], [0.6, 0.6], [1, 1]], 'blue': [[0, 0], [0.3, 0.3], [0.5, 0.5], [1, 0.9299999999999999]] } },
    tint: {
        '0': { 'color': { 'r': 0, 'g': 255, 'b': 36 }, 'amount': 7 },
        '14': { 'color': { 'r': 0, 'g': 255, 'b': 144 }, 'amount': 7 },
        '49': { 'color': { 'r': 0, 'g': 99, 'b': 255 }, 'amount': 7 }, '60': { 'color': { 'r': 0, 'g': 15, 'b': 255 }, 'amount': 7 }, '-79': { 'color': { 'r': 255, 'g': 0, 'b': 58 }, 'amount': 7 }, '-46': { 'color': { 'r': 255, 'g': 195, 'b': 0 }, 'amount': 7 }, '-73': { 'color': { 'r': 255, 'g': 0, 'b': 12 }, 'amount': 7 }, '-50': { 'color': { 'r': 255, 'g': 164, 'b': 0 }, 'amount': 7 },
    },
};

export const GLFXFilters: GLFXFilter = {
    'Normal': {
        name: 'Normal',
        blur: 0,
        brightness: 0,
        contrast: 0,
        tint: 0,
        saturation: 0,
        vignette: 0,
        xpro: 0,
    },
    'The Blues': {
        name: 'The Blues',
        blur: -14,
        brightness: 63,
        contrast: -37,
        tint: 0,
        saturation: -26,
        vignette: 0,
        xpro: -23,
    },
    'Edge': {
        name: 'Edge',
        blur: -53,
        brightness: 10,
        contrast: -24,
        tint: 49,
        saturation: 26,
        vignette: 0,
        xpro: 29,
    },
    'Selfie': {
        name: 'Selfie',
        blur: 0,
        brightness: 10,
        contrast: -12,
        tint: -50,
        saturation: -12,
        vignette: 56,
        xpro: 50,
    },
    'Festive': {
        name: 'Festive',
        blur: -7,
        brightness: 10,
        contrast: 21,
        tint: 0,
        saturation: 24,
        vignette: 0,
        xpro: 40,
    },
    'Rosie': {
        name: 'Rosie',
        blur: -14,
        brightness: 0,
        contrast: 55,
        tint: -73,
        saturation: -28,
        vignette: 0,
        xpro: 27,
    },
    'Drama': {
        name: 'Drama',
        blur: 0,
        brightness: -10,
        contrast: 21,
        tint: 60,
        saturation: -34,
        vignette: 50,
        xpro: 80,
    },
    'Epic': {
        name: 'Epic',
        blur: 1,
        brightness: 6,
        contrast: 20,
        tint: 0,
        saturation: -14,
        vignette: 39,
        xpro: 50,
    },
    'Grayscale': {
        name: 'Grayscale',
        blur: 0,
        brightness: 15,
        contrast: -20,
        tint: 0,
        saturation: -100,
        vignette: 0,
        xpro: 0,
    },
    'Nordic': {
        name: 'Nordic',
        blur: 0,
        brightness: 15,
        contrast: -16,
        tint: 0,
        saturation: -50,
        vignette: 0,
        xpro: 0,
    },
    'Summer': {
        name: 'Summer',
        blur: 0,
        brightness: 10,
        contrast: 14,
        tint: -46,
        saturation: 18,
        vignette: 25,
        xpro: 30,
    },
    'Street': {
        name: 'Street',
        blur: -7,
        brightness: -7,
        contrast: 21,
        tint: 0,
        saturation: -95,
        vignette: 50,
        xpro: 0,
    },
    'Retro': {
        name: 'Retro',
        blur: 0,
        brightness: 0,
        contrast: -14,
        tint: 14,
        saturation: -18,
        vignette: 40,
        xpro: 69,
    },
    'Whimsical': {
        name: 'Whimsical',
        blur: -19,
        brightness: 43,
        contrast: -15,
        tint: -79,
        saturation: -53,
        vignette: 21,
        xpro: 60,
    },
    'Cali': {
        name: 'Cali',
        blur: 0,
        brightness: 22,
        contrast: -46,
        tint: 0,
        saturation: 38,
        vignette: 0,
        xpro: 27,
    },
};

export interface GLFX {
    canvas: () => GLFXCanvas;
}

export interface GLFXCanvas extends HTMLCanvasElement {
    texture: (...args) => any;
    draw: (...args) => any;
    loadContentsOf: (...args) => any;
}

/**
 * Does not modify or give original (reference) GLFXFilters. It always saves and give a cloned version
 */
export class FilterConfig {
    static current_filter: GLFXFilterConfig = GLFXFilters['Normal'];

    public static getCurrentFilterConfig(): GLFXFilterConfig {
        return cloneDeep(FilterConfig.current_filter);
    }
    public static setCurrentFilterConfig(filter_config: GLFXFilterConfig) {
        FilterConfig.current_filter = cloneDeep(filter_config);
    }
}
